var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import isSameDay from 'date-fns/isSameDay';
import React from 'react';
import DatePickerBase from './DatePickerBase';
/**
 * Date picker to select 0 or more dates
 */
var DateMultiPicker = function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? [] : _b, rest = __rest(_a, ["onChange", "value"]);
    return (React.createElement(DatePickerBase, __assign({}, rest, { initialMonth: value[0], onDayClick: function (day) {
            if (onChange) {
                var selectedDay_1 = value.find(function (d) { return isSameDay(d, day); });
                onChange(selectedDay_1 ? value.filter(function (v) { return v !== selectedDay_1; }) : __spreadArray(__spreadArray([], __read(value), false), [day], false));
            }
        }, selectedDays: value })));
};
export default DateMultiPicker;
//# sourceMappingURL=DateMultiPicker.js.map